const compareMoneyFormat = (val) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })
    .format(val)
    .replaceAll('.00', '');
class CompareHelperV2 {
  constructor(productId, collectionId, collectionName, collectionHandle) {
    this.baseProductUrl = `https://www.fpapplications.com/v2/compare?currency=${CURRENCY_CODE}&collection_id=${collectionId}&product_id=${productId}&limit=15`;
    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    this.id = collectionId;
    this.handle = collectionHandle;
    this.collectionName = collectionName;
    this.changeTimeout = setTimeout(() => {}, 1);
    this.showRank = false;
    this.plugMap = {
      '5-20R': {
        image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_20A_GFCI_Outlet.png?v=1612382967',
        name: '120v 20 Amp Standard Receptacle',
      },
      'L5-30R': {
        image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_30A_Twist_Lock.png?v=1612382967',
        name: '120v 30 Amp Twist Lock',
      },
      'L14-30R': {
        image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_240V_30A_Twist_Lock.png?v=1612382967',
        name: '120/240v 30 Amp Twist Lock',
      },
      'L14-50R': {
        image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_240V_50A_Heavy_Duty_Outlet.png?v=1612382967',
        name: '120v/240v 50 Amp Heavy Duty Outlet',
      },
      '14-50R': {
        image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_240V_50A_Heavy_Duty_Outlet.png?v=1612382967',
        name: '120v/240v 50 Amp Heavy Duty Outlet',
      },
      'TT-30R': {
        image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/120V_TT-30R.png?v=1612813988',
        name: '120v 30 Amp RV Ready',
      },
      'L14-20R': {
        image_url: 'https://cdn.shopify.com/s/files/1/1163/1976/files/125V_250V_20_Amp_Twist_Lock.png?v=1613276582',
        name: '125v/250v 20 Amp Twist Lock',
      },
    };
  }
  async init() {
    const crossWrapper = document.querySelector('.pdp__cross__wrapper');
    const splideConfig = crossWrapper
      ? {
          type: 'slide',
          perPage: 4,
          rewindByDrag: true,
          rewind: true,
          pagination: false,
          breakpoints: {
            1536: {
              perPage: 3,
            },
            1200: {
              perPage: 2,
            },
            500: {
              perPage: 1,
              padding: { right: '15%' },
            },
          },
        }
      : {
          type: 'slide',
          perPage: 6,
          rewindByDrag: true,
          rewind: true,
          pagination: false,
          breakpoints: {
            1536: {
              perPage: 5,
            },
            1200: {
              perPage: 4,
            },
            500: {
              perPage: 1,
              padding: { right: '15%' },
            },
          },
        };
    await fetch(this.baseProductUrl + '&order_by=relevance&include_filters=true')
      .then((res) => res.json())
      .then((res) => {
        if (!res.success || !res.products || res.products.length < 2) {
          document.querySelector('.pdp__compare__wrapper').remove();
          document.querySelector('.pdp__compare__mobile').remove();
          return;
        }
        this.filters = res.filters;
        this.compareProduct = res.compareProduct;
        res.products.forEach((p, index) => {
          document.querySelector('.pdp__compare__splide__list').innerHTML += this.renderCard(p, index);
        });
        document.querySelector('.js-compare-sort').innerHTML = this.buildFilters();
        this.listen();
        let showFeatures = false;
        const featurePanels = [];
        Array.from(document.querySelectorAll('.pdp__compare__slide__features')).forEach((f) => {
          featurePanels.push(f);
          if (Array.from(f.querySelectorAll('.pdp__compare__slide__features__feature')).length === 0) {
            f.querySelector('.features-text').style.display = 'none';
          } else {
            showFeatures = true;
          }
        });
        if (!showFeatures) {
          featurePanels.forEach((p) => (p.style.display = 'none'));
        }
        this.splide = new Splide('.js-compare-splide', splideConfig).mount();
      })
      .catch((err) => {
        console.log(err);
        document.querySelector('.pdp__compare__wrapper').remove();
        if (!document.querySelector('.pdp__cross__wrapper')) {
          document.querySelector('.pdp__related').remove();
        } else {
          document.querySelector('.pdp__cross__wrapper').style.width = '100%';
          document.querySelector('.pdp__compare__mobile').remove();
        }
      });
  }
  fetchAndRender() {
    this.buildFetchUrl();
    fetch(this.currentFetchUrl)
      .then((res) => res.json())
      .then((res) => {
        document.querySelector('.pdp__compare__splide__list').innerHTML = '';
        res.products.forEach((p, index) => {
          document.querySelector('.pdp__compare__splide__list').innerHTML += this.renderCard(p, index);
        });
        if (res.products.length === 0) {
          document.querySelector('.pdp__compare__no-results').classList.add('pdp__compare__no-results--visible');
        } else {
          document.querySelector('.pdp__compare__no-results').classList.remove('pdp__compare__no-results--visible');
        }
        Array.from(document.querySelectorAll('.pdp__compare__slide__features')).forEach((f) => {
          if (Array.from(f.querySelectorAll('.pdp__compare__slide__features__feature')).length === 0) {
            f.style.display = 'none';
          }
        });
        this.splide.refresh();
        this.splide.go(0);
      });
  }
  renderCard(product) {
    return `
            <li
                class="splide__slide box pdp__compare__splide__slide ${
                  product.is_current_product ? 'current-product ' : ''
                }${product.compare_at_price ? 'on-sale' : ''}"
            >
                <div class="pdp__compare__slide__inner">
                    ${
                      this.isNew(product.created_at)
                        ? `
                        <div class="pdp__compare__slide__new-banner ${
                          product.is_current_product ? 'pdp__compare__slide__new-banner--current' : ''
                        }">
                            <img
                                src="https://cdn.shopify.com/s/files/1/1163/1976/files/NewBanner.png?v=1600563036"
                                class="pdp__compare__slide__new-banner__img"
                                alt="new banner"
                                width="150"
                                height="50"
                                loading="lazy"
                            >
                        </div>
                    `
                        : ''
                    }
                    ${
                      product.is_current_product
                        ? `
                        <div class="pdp__compare__slide__current-header">
                            CURRENT ITEM
                        </div>
                    `
                        : ''
                    }
                    <a href="/products/${product.handle}" class="pdp__compare__slide__link">
                        <div class="pdp__compare__slide__image-container">
                            <img
                                class="pdp__compare__slide__img"
                                src="${product.featured_image}&width=300"
                                alt="${product.title}"
                                width="400"
                                height="400"
                                loading="lazy"
                            >
                            ${
                              this.getStock(product) === 'OOS'
                                ? `
                                <div class="pdp__compare__badge">
                                    SOLD OUT
                                </div>
                            `
                                : ''
                            }
                            ${
                              this.isSale(product)
                                ? `
                                <div class="pdp__compare__badge__container">
                                    <div class="pdp__compare__badge pdp__compare__badge--on-sale">
                                        SALE
                                    </div>
                                </div>
                            `
                                : ''
                            }
                        </div>
                        <h3 class="pdp__compare__slide__heading">${product.title}</h3>
                        <p class="pdp__compare__slide__price">${this.formatPrice(product.price)}</p>
                    </a>
                    <div class="pdp__compare__slide__details">
                        ${
                          this.showRank
                            ? `
                            <div class="pdp__compare__slide__rank">
                                <p class="pdp__compare__slide__rank__text">
                                  <strong>#${product.selling_rank}</strong> Selling in ${this.collectionName}
                                </p>
                            </div>
                        `
                            : ''
                        }
                        <div class="pdp__compare__slide__features">
                            <div class="features-text">
                                <div class="tooltip">
                                    <u style="opacity:.9; font-weight:bold;">Features</u>
                                </div>
                            </div>

                            ${this.renderFeatures(product.features, this.compareProduct.features)}
                        </div>
                        <div class="pdp__compare__slide__reviews">
                            ${product.judgeme_badge}
                        </div>
                    </div>
                </div>
            </li>
            `;
  }
  renderVendors(vendors) {
    return vendors
      .sort((a, b) => {
        return a < b ? -1 : 1;
      })
      .map(
        (vendor) => `
        <div class="pdp__compare__filter__option">
            <input 
                class="pdp__compare__filter__input pdp__compare__filter__input--vendor" 
                type="checkbox" 
                name="vendor-${vendor}" 
                id="vendor-${vendor}" 
                value="${vendor}"
            />
            <label for="vendor-${vendor}" class="pdp__compare__filter__label">${vendor}</label>
        </div>
    `
      )
      .join('\n');
  }
  renderCheckbox(group_name, disjunctive, values) {
    return values
      .sort((a, b) => {
        return a < b ? -1 : 1;
      })
      .map((value) => {
        const plug = this.plugMap[value];
        return `
              <div class="pdp__compare__filter__option">
              ${
                plug
                  ? `<img 
                      src="${plug.image_url}" 
                      alt="${plug.name}" 
                      style="pointer-events: none; width: 48px; height: 48px; position: relative; z-index: 2; margin: 0 auto 8px; display: block;" 
                      width="auto"
                      height="auto"
                      loading="lazy"
                    />`
                  : ''
              }
                  <input 
                      class="pdp__compare__filter__input pdp__compare__filter__input--tag" 
                      type="checkbox" 
                      name="${group_name}-${value}" 
                      id="${group_name}-${value}" 
                      value="${disjunctive ? `d__${group_name}__${value}` : `c__${group_name}__${value}`}"
                  />
                  <label for="${group_name}-${value}" class="pdp__compare__filter__label">${
          this.handle === 'standby' && value === 'Liquid Propane' ? 'Liquid Propane or Natural Gas' : value
        }</label>
              </div>
          `;
      })
      .join('\n');
  }
  renderRadio(group_name, disjunctive, values) {
    return values
      .sort((a, b) => {
        return a < b ? -1 : 1;
      })
      .map(
        (value) => `
              <div class="pdp__compare__filter__option">
                  <input 
                      class="pdp__compare__filter__input pdp__compare__filter__input--tag" 
                      type="radio" 
                      name="${group_name}" 
                      id="${group_name}-${value}" 
                      value="${disjunctive ? `d__${group_name}__${value}` : `c__${group_name}__${value}`}"
                  />
                  <label for="${group_name}-${value}" class="pdp__compare__filter__label">${
          this.handle === 'standby' && value === 'Liquid Propane' ? 'Liquid Propane or Natural Gas' : value
        }</label>
              </div>
          `
      )
      .join('\n');
  }
  renderRange(group_name, unit, high, step) {
    return `
      <div 
        class="range-slider js-range-slider"
        data-group-name="${group_name}"
        data-min="0"
        data-max="${high}"
      >
        <div class="range-slider__inner">
          <input
            id="min-${group_name}"
            type="range"
            min="0"
            max="${high}"
            value="0"
            step="${step || high / 100}"
            class="range-slider__input"
          />
          <label for="min-${group_name}" class="range-slider__display range-slider__display--low">
            <span class="range-slider__amount">0</span>
            <span class="range-slider__unit">${unit}</span>
          </label>
          <input
            id="max-${group_name}"
            type="range"
            min="0"
            max="${high}"
            value="${high}"
            step="${step || high / 100}"
            class="range-slider__input"
          />
          <label for="max-${group_name}" class="range-slider__display range-slider__display--high">
            <span class="range-slider__amount">${high}</span>
            <span class="range-slider__unit">${unit}</span>
          </label>
        </div>
      </div>  
    `;
  }
  isNew(created_at) {
    const diff = Date.now() - 180 * 24 * 60 * 60 * 1000;
    const curr = new Date(created_at).getTime();
    return curr > diff;
  }
  getStock(product) {
    const stock =
      product.tracks_inventory === 1 && product.inventory_quantity < 1 && product.inventory_policy === 'deny'
        ? 'OOS'
        : product.tracks_inventory === 1 && product.inventory_quantity < 1 && product.inventory_policy === 'continue'
        ? 'PRE'
        : 'INSTOCK';
    return stock;
  }
  isSale(product) {
    const vendor_processing_time = product.vendor_processing_time ? JSON.parse(product.vendor_processing_time) : {};
    const processing_time = product.processing_time ? JSON.parse(product.processing_time) : {};
    let onSale = false;
    if (
      (vendor_processing_time &&
        vendor_processing_time.pdp_line_1 &&
        vendor_processing_time.pdp_line_1.includes(':')) ||
      (vendor_processing_time &&
        vendor_processing_time.pdp_line_1 &&
        vendor_processing_time.pdp_line_1?.toUpperCase().includes('ADD TO CART'))
    ) {
      onSale = true;
    } else if (vendor_processing_time && vendor_processing_time.pdp_line_1) {
      onSale = false;
    }
    if (
      (processing_time && processing_time.pdp_line_1 && processing_time.pdp_line_1.includes(':')) ||
      (processing_time &&
        processing_time.pdp_line_1 &&
        processing_time.pdp_line_1?.toUpperCase().includes('ADD TO CART'))
    ) {
      onSale = true;
    } else if (processing_time && processing_time.pdp_line_1) {
      onSale = false;
    }
    if (product.compare_at_price) onSale = true;
    return onSale;
  }
  formatPrice(price) {
    return this.moneyFormatter.format(price).replace('.00', '');
  }
  renderFeatures(features, compareProductFeatures) {
    const featureArray = (features || '').split(',').filter((v) => v);
    return featureArray
      .map((feature) => {
        if (compareProductFeatures && compareProductFeatures.includes(feature)) {
          return `<span class="pdp__compare__slide__features__feature">${feature}</span>`;
        } else {
          return `<span class="pdp__compare__slide__features__feature pdp__compare__slide__features__feature--grey">${feature}</span>`;
        }
      })
      .join(', ');
  }
  buildFilters() {
    return `
            <p class="pdp__compare__sort__title">Sort:</p>
            <div class="pdp__compare__sort__option">
                <input class="pdp__compare__sort__input" type="radio" name="compare-sort" id="sort-rank" value="sort-rank" checked>
                <label for="sort-rank" class="pdp__compare__sort__label">Relevance</label>
            </div>
            <div class="pdp__compare__sort__option">
                <input class="pdp__compare__sort__input" type="radio" name="compare-sort" id="sort-best-selling" value="best-selling">
                <label for="sort-best-selling" class="pdp__compare__sort__label" tabindex='0'>Best Selling</label>
            </div>
            <div class="pdp__compare__splitter">&nbsp;</div>
            <div class="pdp__compare__filter-trigger">Filter</div>
            <button class="pdp__compare__arrow pdp__compare__arrow--prev" type="button">
                <span style="position:absolute;width:0;height:0;overflow:hidden;z-index:-5">filter scroll previous</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false" aria-label='previous arrow'>
                    <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                </svg>
            </button>
            <div class="pdp__compare__filter-container">
                <p class="pdp__compare__sort__title">Filter:</p>
                <div class="pdp__compare__filter__close">&times;</div>
                <div class="pdp__compare__sort__clear">Clear Filters</div>
                <div class="pdp__compare__sort__item" tabindex='0'>
                    <p class="pdp__compare__sort__heading">Price</p>
                    <div class="pdp__compare__sort__content">
                        <div class="pdp__compare__sort__content__inner">
                          ${this.renderRange('Price', '', Math.ceil(this.filters.price_range[1]) + 1, 1)}
                        </div>
                    </div>
                </div>
                <div class="pdp__compare__sort__item" tabindex='0'>
                      <p class="pdp__compare__sort__heading">Brand</p>
                      <div class="pdp__compare__sort__content">
                          <div class="pdp__compare__sort__content__inner">
                              ${this.renderVendors(this.filters.vendors)}
                          </div>
                      </div>
                  </div>
                ${Object.entries(this.filters.filters)
                  .filter(
                    ([group_name, filter_value]) => filter_value.type === 'range' && group_name !== 'Peak Wattage'
                  )
                  .map(([group_name, filter_value]) => {
                    const { unit, values } = filter_value;
                    return `
                        <div class="pdp__compare__sort__item" tabindex='0'>
                            <p class="pdp__compare__sort__heading">${group_name}</p>
                            <div class="pdp__compare__sort__content">
                                <div class="pdp__compare__sort__content__inner">
                                    ${this.renderRange(group_name, unit, values[1])}
                                </div>
                            </div>
                        </div>
                    `;
                  })
                  .join('\n')}
                ${Object.entries(this.filters.filters)
                  .filter(([group_name, filter_value]) => filter_value.type !== 'range')
                  .map(([group_name, filter_value]) => {
                    const { disjunctive, type, unit, values } = filter_value;
                    if (type === 'checkbox') {
                      return `
                        <div class="pdp__compare__sort__item" tabindex='0'>
                            <p class="pdp__compare__sort__heading">${group_name}</p>
                            <div class="pdp__compare__sort__content">
                                <div class="pdp__compare__sort__content__inner">
                                    ${this.renderCheckbox(group_name, disjunctive, values)}
                                </div>
                            </div>
                        </div>
                    `;
                    } else if (type === 'radio') {
                      return `
                        <div class="pdp__compare__sort__item" tabindex='0'>
                            <p class="pdp__compare__sort__heading">${group_name}</p>
                            <div class="pdp__compare__sort__content">
                                <div class="pdp__compare__sort__content__inner">
                                    ${this.renderRadio(group_name, disjunctive, values)}
                                </div>
                            </div>
                        </div>
                    `;
                    }
                  })
                  .join('\n')}
            <div class="pdp__compare__filter__apply">SHOW</div>
        </div>
        <button class="pdp__compare__arrow pdp__compare__arrow--next pdp__compare__arrow--visible" type="button">
            <span style="position:absolute;width:0;height:0;overflow:hidden;z-index:-5">filter scroll next</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false" aria-label='next arrow'>
            <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
            </svg>
        </button>
      `;
  }
  listen() {
    window.addEventListener('resize', () => {
      recalculateHeight();
    });
    window.addEventListener('load', () => {
      recalculateHeight();
      if (
        !document.querySelector('.pdp__cross__wrapper') ||
        document.querySelector('.pdp__cross__wrapper').style.display == 'none'
      ) {
        document.querySelector('.pdp__compare__wrapper').style.width = '100%';
        this.splide.destroy({ completely: true });
        this.splide = new Splide('.js-compare-splide', {
          type: 'slide',
          perPage: 6,
          rewindByDrag: true,
          rewind: true,
          pagination: false,
          breakpoints: {
            1536: {
              perPage: 5,
            },
            1200: {
              perPage: 4,
            },
            1000: {
              perPage: 2,
            },
            500: {
              perPage: 1,
              padding: { right: '20%' },
            },
          },
        }).mount();
      }
    });
    function recalculateHeight() {
      const featureBoxes = document.querySelectorAll('.pdp__compare__slide__features');
      let maxHeight = 0;
      for (const box of featureBoxes) {
        box.style.height = '';
      }
      for (const box of featureBoxes) {
        if (maxHeight < box.clientHeight) {
          maxHeight = box.clientHeight;
        }
      }
      for (const box of featureBoxes) {
        box.style.height = maxHeight + 'px';
      }
    }
    const rangeSliders = Array.from(document.querySelectorAll('.js-range-slider .range-slider__inner'));
    for (let slider of rangeSliders) {
      let sliderTimeout = setTimeout(() => {}, 0);
      const sliderParent = slider.parentNode;
      const isPrice = sliderParent.dataset.groupName === 'Price';
      const sliderInputs = Array.from(slider.querySelectorAll('input'));
      const labels = Array.from(slider.querySelectorAll('.range-slider__display'));
      sliderInputs.forEach((input) => {
        updateSliderVisuals(null, isPrice);
        input.addEventListener('input', ({ target }) => {
          clearTimeout(sliderTimeout);
          updateSliderVisuals(target, isPrice);
          sliderTimeout = setTimeout(() => {
            this.fetchAndRender();
          }, 500);
        });
        input.addEventListener('change', ({ target }) => {
          clearTimeout(sliderTimeout);
          updateSliderVisuals(target, isPrice);
          sliderTimeout = setTimeout(() => {
            this.fetchAndRender();
          }, 500);
        });
      });
      function updateSliderVisuals(target, isPrice) {
        const [low, high] = sliderInputs;
        const [lowLabel, highLabel] = labels;
        if (parseFloat(low.value) > parseFloat(high.value) - parseFloat(high.max) * 0.15) {
          lowLabel.classList.add('range-slider__display--low--close');
          highLabel.classList.add('range-slider__display--high--close');
        } else {
          lowLabel.classList.remove('range-slider__display--low--close');
          highLabel.classList.remove('range-slider__display--high--close');
        }
        if (target) {
          if (target === low) {
            if (parseFloat(low.value) > parseFloat(high.value) - parseFloat(high.max) * 0.01) {
              low.value = parseFloat(high.value) - parseFloat(high.max) * 0.01;
            }
          }
          if (target === high) {
            if (parseFloat(high.value) < parseFloat(low.value) + parseFloat(low.max) * 0.01) {
              high.value = parseFloat(low.value) + parseFloat(low.max) * 0.01;
            }
          }
        }
        slider.style.background = `linear-gradient(
          to right,
          transparent ${(parseFloat(low.value) / parseFloat(low.max)) * 100}%,
          var(--blue) ${(parseFloat(low.value) / parseFloat(low.max)) * 100}%,
          var(--blue) ${(parseFloat(high.value) / parseFloat(high.max)) * 100}%,
          transparent ${(parseFloat(high.value) / parseFloat(high.max)) * 100}%
        )`;
        lowLabel.style.left = `calc(${(parseFloat(low.value) / parseFloat(low.max)) * 100 + '%'} + ${
          10 - (parseFloat(low.value) / parseFloat(low.max)) * 20 + 'px'
        })`;
        lowLabel.children[0].innerText = isPrice
          ? compareMoneyFormat(low.value)
          : compareHelperNumberWithCommas(low.value);
        highLabel.style.right = `calc(${100 - (parseFloat(high.value) / parseFloat(high.max)) * 100 + '%'} - ${
          10 - (parseFloat(high.value) / parseFloat(high.max)) * 20 + 'px'
        })`;
        highLabel.children[0].innerText = isPrice
          ? compareMoneyFormat(high.value)
          : compareHelperNumberWithCommas(high.value);
      }
    }
    const handleChangeRange = ({ target }) => {
      const parent = target.parentNode.parentNode;
      const relatedInputs = Array.from(parent.querySelectorAll('.js-range-input'));
      const [lowInput, highInput] = relatedInputs;
      if (target == lowInput) {
        if (parseFloat(target.value) > parseFloat(highInput.value)) {
          target.value = highInput.value;
        }
      }
      if (target == highInput) {
        if (parseFloat(target.value) < parseFloat(lowInput.value)) {
          target.value = lowInput.value;
        }
      }
      this.fetchAndRender();
    };
    const rangeInputs = Array.from(document.querySelectorAll('.js-range-input'));
    for (let range of rangeInputs) {
      range.addEventListener('change', handleChangeRange);
    }

    Array.from(document.querySelectorAll('.pdp__compare__sort__input')).forEach((input) => {
      input.addEventListener('change', (e) => {
        if (e.target.checked) {
          if (e.target.id === 'sort-best-selling') {
            this.showRank = true;
          } else {
            this.showRank = false;
          }
          this.fetchAndRender();
        }
      });
    });
    Array.from(document.querySelectorAll('.pdp__compare__filter__input')).forEach((input) => {
      input.addEventListener('change', () => this.fetchAndRender());
    });
    const prevArrow = document.querySelector('.pdp__compare__arrow--prev');
    const nextArrow = document.querySelector('.pdp__compare__arrow--next');
    const filterScroller = document.querySelector('.pdp__compare__filter-container');
    prevArrow.addEventListener('click', () => {
      const endPosition = filterScroller.scrollLeft - 300;
      filterScroller.scrollTo({ left: endPosition, behavior: 'smooth' });
      if (endPosition <= 0) {
        prevArrow.classList.remove('pdp__compare__arrow--visible');
      }
    });
    nextArrow.addEventListener('click', () => {
      filterScroller.scrollTo({ left: filterScroller.scrollLeft + 300, behavior: 'smooth' });
      prevArrow.classList.add('pdp__compare__arrow--visible');
    });
    let resizeTimeout = setTimeout(() => {
      if (filterScroller.offsetWidth < filterScroller.scrollWidth) {
        nextArrow.classList.add('pdp__compare__arrow--visible');
      } else {
        nextArrow.classList.remove('pdp__compare__arrow--visible');
      }
    }, 500);
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (filterScroller.offsetWidth < filterScroller.scrollWidth) {
          nextArrow.classList.add('pdp__compare__arrow--visible');
        } else {
          nextArrow.classList.remove('pdp__compare__arrow--visible');
        }
      }, 200);
    });
    document.querySelector('.pdp__compare__sort__clear').addEventListener('click', () => {
      Array.from(document.querySelectorAll('.pdp__compare__filter__input')).forEach((input) => (input.checked = false));
      Array.from(document.querySelectorAll('.js-range-slider')).forEach((slider) => {
        const [lowInput, highInput] = Array.from(slider.querySelectorAll('input'));
        lowInput.value = slider.dataset.min;
        highInput.value = slider.dataset.max;
        lowInput.dispatchEvent(new Event('change'));
      });
      document.querySelector('#min-Price').value = '0';
      document.querySelector('#max-Price').value = `${Math.ceil(this.filters.price_range[1]) + 1}`;
      document.querySelector('.pdp__compare__sort__clear').style.display = '';
      document.querySelector('#sort-rank').checked = true;
      document.querySelector('#sort-best-selling').checked = false;
      this.fetchAndRender();
    });
    const applyFilterBtn = document.querySelector('.pdp__compare__filter__apply');
    const filterTrigger = document.querySelector('.pdp__compare__filter-trigger');
    const filterClose = document.querySelector('.pdp__compare__filter__close');
    filterTrigger.addEventListener('click', () => {
      filterScroller.classList.add('pdp__compare__filter-container--open');
    });
    applyFilterBtn.addEventListener('click', () => {
      filterScroller.classList.remove('pdp__compare__filter-container--open');
    });
    filterClose.addEventListener('click', () => {
      filterScroller.classList.remove('pdp__compare__filter-container--open');
    });
    const sortTriggers = document.querySelectorAll('.pdp__compare__sort__heading');
    sortTriggers.forEach((trigger) =>
      trigger.addEventListener('click', () => {
        if (window.innerWidth <= 1000) {
          sortTriggers.forEach((t) => {
            if (t !== trigger) {
              t.nextElementSibling.classList.remove('pdp__compare__sort__content--open');
              t.nextElementSibling.style.maxHeight = '';
              t.classList.remove('pdp__compare__sort__heading--open');
            }
          });
          if (trigger.nextElementSibling.classList.contains('pdp__compare__sort__content--open')) {
            trigger.nextElementSibling.classList.remove('pdp__compare__sort__content--open');
            trigger.nextElementSibling.style.maxHeight = '';
            trigger.classList.remove('pdp__compare__sort__heading--open');
          } else {
            trigger.nextElementSibling.classList.add('pdp__compare__sort__content--open');
            trigger.nextElementSibling.style.maxHeight = trigger.nextElementSibling.scrollHeight + 'px';
            trigger.classList.add('pdp__compare__sort__heading--open');
          }
        }
      })
    );
  }
  buildFetchUrl() {
    const vendor = Array.from(document.querySelectorAll('.pdp__compare__filter__input--vendor:checked')).map(
      (input) => input.value
    );
    const checkboxesAndRadios = Array.from(document.querySelectorAll('.pdp__compare__filter__input--tag:checked')).map(
      (input) => input.value
    );
    const ranges = Array.from(document.querySelectorAll('.js-range-slider'))
      .map((v) => {
        if (v.dataset.groupName === 'Price') {
          return;
        }
        const [lowElement, highElement] = Array.from(v.querySelectorAll('input'));
        const groupName = v.dataset.groupName;
        const defaultMin = v.dataset.min;
        const defaultMax = v.dataset.max;
        const currentMin = lowElement.value;
        const currentMax = highElement.value;

        if (defaultMin !== currentMin || defaultMax !== currentMax) {
          return `r__${groupName}__${currentMin}-${currentMax}`;
        }
      })
      .filter((v) => v);
    const tags = [...checkboxesAndRadios, ...ranges];
    const lowestPrice = document.querySelector('#min-Price').value;
    const highestPrice = document.querySelector('#max-Price').value;
    const sort = document.querySelector("input[value='best-selling']");
    this.currentFetchUrl = this.baseProductUrl;
    let filtered = false;
    if (vendor.length > 0) {
      filtered = true;
      this.currentFetchUrl += `&vendor=${vendor.join(',')}`;
    }
    if (tags.length > 0) {
      filtered = true;
      this.currentFetchUrl += `&tags=${tags.join(',')}`;
    }
    if (parseInt(lowestPrice) !== 0 || parseInt(highestPrice) !== Math.ceil(this.filters.price_range[1]) + 1) {
      filtered = true;
      this.currentFetchUrl += `&price=${lowestPrice},${highestPrice}`;
    }
    if (sort.checked) {
      filtered = true;
      this.currentFetchUrl += `&order_by=best-selling`;
    }
    this.updateSelectedItems();
    this.toggleClearFilterBtn(filtered);
  }
  toggleClearFilterBtn(filtered) {
    const filterScroller = document.querySelector('.pdp__compare__filter-container');
    const nextArrow = document.querySelector('.pdp__compare__arrow--next');
    setTimeout(() => {
      if (filterScroller.offsetWidth < filterScroller.scrollWidth) {
        nextArrow.classList.add('pdp__compare__arrow--visible');
      } else {
        nextArrow.classList.remove('pdp__compare__arrow--visible');
      }
    }, 200);
    if (filtered) {
      document.querySelector('.pdp__compare__sort__clear').style.display = 'block';
    } else {
      document.querySelector('.pdp__compare__sort__clear').style.display = '';
    }
  }
  updateSelectedItems() {
    const headings = Array.from(document.querySelectorAll('.pdp__compare__sort__heading'));
    headings.forEach((h) => {
      const headingName = h.innerText.split('(')[0].trim();
      const checkedBoxes = Array.from(h.nextElementSibling.querySelectorAll('input:checked'));
      if (checkedBoxes.length > 0) {
        h.innerText = `${headingName} (${checkedBoxes.length})`;
      } else {
        h.innerText = headingName;
      }
    });
  }
}
function compareHelperNumberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
